export default __webpack_public_path__ + "a4f660c2fbd3b6f3359673db38b6ace7.svg";